import * as S from "./style";
import { useEffect, useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router";
import NewModal from "../../../LayoutModal";
//hooks
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from "../../../../hooks/useLoading";
//Interface
import { Inputs } from "Interfaces/IPayment";
import { IOrder } from "Interfaces/IOrder";
import { IMethPay } from "Interfaces/IMethodPaym";
//Utils
import { CurrencyFormat } from "utils/CurrencyFormat";
import { HandleSelectedPayment } from "utils/FunctionPayment";
//Forma de Pagamento
import CreditCard from "../CreditCard";
import CombinedPayment from "../CombinedPayment";
import CreditStorePayment from "../Crediario";
import axiosInstance from "services/axiosInstance";
import axios from "axios";

interface ICreat {
  isOpen: boolean;
  setModalClose: () => void;
  subtotal: number;
  dataRequest: any;
}

export default function CreatePayment({
  isOpen,
  setModalClose,
  subtotal,
  dataRequest
}: ICreat) {

  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    reset,
    resetField,
    getValues,
    watch,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const navigate = useNavigate();
  const { isLoading, startLoading, stopLoading } = useLoading();
  let payload = {};
  const [totalSale, setTotalSale] = useState(subtotal);
  const [saleIdState, setSaleIdState] = useState<number | null>(null);

  const [selecPaymentMeth, setSelecPaymentMeth] = useState('');
  const [paymentMethod, setPaymentMethod] = useState<IMethPay[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("payment-method");
        setPaymentMethod(response.data);
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    fetchData();
  }, []);

  /**
   * Realiza cadastro do pagamento
   * @param data
   */
  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {

      let saleId = saleIdState || null;
      let responseSale = null;

      if (!saleId) {
        responseSale = await finalizeSale(data.payment_method_id);
        if (responseSale && responseSale.saleId) {
          saleId = responseSale.saleId;
          setSaleIdState(responseSale.saleId);
        }
      } else {
        responseSale = { saleId, status: 200 }; // Simulando um objeto de venda com o ID existente
      }

      if (selecPaymentMeth) {
        // Pagamento no Crédito
        payload = {
          card_id: data.card_id?.find((val) => val) || 0,
          sale_id: saleId,
        };

        // Construa as portions - Dados do Pagamento Combinado
        const portions = Array.isArray(data.form_payment_id) ? (
          data.form_payment_id.map((formPaymentId, index) => ({
            form_payment_id: Number(formPaymentId),
            card_id: data.card_id ? data.card_id[index] : null,
            amount: data.amount[index] || 0,
          }))
        ) : [];

        if (portions.length > 0) {
          payload = {
            sale_id: saleId,
            discount: data.discount,
            portions
          };
        }

        //Crediário da Loja
        const installments = Array.isArray(data.due_date) ? (
          data.due_date.map((dateId, index) => ({
            due_date: dateId,
            amount: data.amount[index] || 0,
          }))
        ) : [];

        if (installments.length > 0) {
          payload = {
            sale_id: saleId,
            card_id: data.card_id?.find((val) => val) || null,
            form_payment_id: data.form_payment_id || null,
            down_payment: data.down_payment,
            installments
          };
        }

        const responsePay = await apiRequest(selecPaymentMeth, "POST", payload);
        const statusPay = responsePay.status;
        if (statusPay === 201) {
          alert("Venda finalizada com sucesso!");
          navigate('/venda');
        } else {
          throw new Error("Erro ao cadastrar a Pagamento.");
        }
      } else if (responseSale && responseSale.status === 201) {
        alert("Venda finalizada com sucesso!");
        navigate('/venda');
      }

    } catch (error: any) {
      alert(
        error.message || error.error || "Ocorreu um erro ao criar a venda."
      );
    } finally {
      stopLoading();
    }
  };

  // Cadastrar a venda e obter o ID
  const finalizeSale = async (payment_id: number) => {
    try {
      const payload = {
        ...dataRequest,
        payment_method_id: payment_id
      }
      const response = await apiRequest<IOrder>("save-sale", "POST", payload);
      if (response.status === 201) {
        const saleId = response.data?.id || null;
        const status = response.status;

        setSaleIdState(saleId);
        return { saleId, status };
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao processar a venda.");
      return null;
    }
  };

  const handlePayment = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const result = HandleSelectedPayment(event);
    if (result) {
      setSelecPaymentMeth(result.name);
    } else {
      setSelecPaymentMeth('');
    }
  };

  const onClose = async () => {
    setModalClose();
    reset();
  };

  if (isOpen) {
    return (
      <S.Container>
        <NewModal
          statusLoad={isLoading}
          title="Área de Pagamento"
          subTitle="Preencha os dados da forma de pagamento."
          setModalClose={onClose}
          submiteModal={handleFormSubmit(onSubmit)}
          nameSubmit="Finalizar venda"
        >
          <S.Content>
            <S.SeparateDiv>
              <S.infor>
                <S.SubTitle>Resumo da Compra</S.SubTitle>
                <S.Title>{CurrencyFormat(subtotal || 0)}</S.Title>
              </S.infor>
            </S.SeparateDiv>

            <S.FormInput>
              <S.Label>
                Forma de Pagamento
                <span>*</span>
              </S.Label>
              <S.Select
                {...register('payment_method_id', { required: true })}
                onChange={(e) => handlePayment(e)}>
                <option value="">Selecione</option>
                {
                  paymentMethod.map((val) => {
                    return <option value={val.id} key={val.id}>{val.payment_method}</option>;
                  })
                }
              </S.Select>
              {errors.payment_method_id && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>

            {selecPaymentMeth === "credit-card" && (
              <CreditCard
                register={register}
                errors={errors}
                reset={reset}
                resetField={resetField}
                subtotal={subtotal || 0}
              />
            )}

            {selecPaymentMeth === "combined-payment" && (
              <CombinedPayment
                totalWithDiscount={setTotalSale}
                watch={watch}
                getValues={getValues}
                register={register}
                errors={errors}
                reset={reset}
                resetField={resetField}
                subtotal={subtotal}
                control={control}
              />
            )}

            {selecPaymentMeth === "payment-credit" && (
              <CreditStorePayment
                setValue={setValue}
                totalWithDiscount={setTotalSale}
                watch={watch}
                getValues={getValues}
                register={register}
                errors={errors}
                reset={reset}
                resetField={resetField}
                subtotal={subtotal}
                control={control}
              />
            )}
          </S.Content>
        </NewModal>
      </S.Container>
    );
  }
  return null;
}
